<template>
    <div class="relative h-full w-full overflow-hidden">
        <div></div>
        <img
            v-for="(image, index) of carouselItem"
            :key="index"
            :src="image.elements[0].url"
            :alt="image.elements[0].title"
            :loading="(index == currentImageIndex || index == rightImageIndex || index == leftImageIndex) ? 'eager' : 'lazy'"
            :class="(index == leftImageIndex ? (leftImageIndex == lastImageIndex ? 'translate-x-[100%]' : '-translate-x-[100%]')
                : index == rightImageIndex ? (rightImageIndex == 0 ? '-translate-x-[100%]' : 'translate-x-[100%]')
                    : index == currentImageIndex ? '-translate-x-1/2'
                        : 'hidden')"
            class="transition-all object-cover object-center min-h-full absolute top-1/2 -translate-y-1/2 left-1/2 min-w-[240px]"
        />
        <button v-show="scrollable" @click.prevent="currentImageIndex = leftImageIndex" class="glide__arrow transition" data-glide-dir="<">
            <v-icon size="6" icon="angle-left" class="stroke-[0.5px] stroke-black"></v-icon>
        </button>
        <button v-show="scrollable" @click.prevent="currentImageIndex = rightImageIndex" class="glide__arrow transition" style="right: 0" data-glide-dir=">">
            <v-icon size="6" icon="angle-right" class="stroke-[0.5px] stroke-black"></v-icon>
        </button>
        <span v-show="scrollable" class="absolute top-3 right-3 bg-white rounded-2xl opacity-60 leading-3 text-[10px] px-1 transition image-number">
            {{ currentImageIndex + 1 }}/{{ lastImageIndex + 1 }}
        </span>
        <div v-show="scrollable" class="absolute bottom-0 w-full px-5 flex items-center justify-center">
            <div
                v-for="(image, index) of carouselItem"
                :key="index"
                @click.prevent="currentImageIndex = index"
                style="transition: width 150ms"
                class="cursor-pointer flex items-center justify-center transition"
                :class="index == currentImageIndex
                    ? 'opacity-100 h-6 w-[9px]'
                        : (index < currentImageIndex + 2 && index > currentImageIndex - 2)
                            ? 'opacity-80 hover:opacity-100 h-5 w-[7px]'
                                : (index < currentImageIndex + 3 && index > currentImageIndex - 3)
                                    ? 'opacity-60 hover:opacity-100 h-4 w-[7px]'
                                        : 'w-0 h-0 opacity-0'"
            >
                <span
                    class="block bg-white transition aspect-square h-1/4 rounded-full border-[0.5px] border-black"
                ></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        carouselItem: {
            type: Array,
            required: true,
        },
    },
    mounted() {
        this.scrollable = this.carouselItem?.length > 1;
    },
    data() {
        return {
            currentImageIndex: 0,
            scrollable: false,
        };
    },
    computed: {
        lastImageIndex() {
            if (this.scrollable) {
                return this.carouselItem.length - 1
            }
        },
        leftImageIndex() {
            if (this.scrollable) {
                return (this.currentImageIndex === 0) ? this.lastImageIndex : this.currentImageIndex - 1;
            }
        },
        rightImageIndex() {
            if (this.scrollable) {
                return (this.currentImageIndex === this.lastImageIndex) ? 0 : this.currentImageIndex + 1;
            }
        },
    },
};
</script>

<style>
.carousel-item .title {
    max-height: 42px;
    transition: max-height cubic-bezier(0.4, 0, 0.2, 1) 150ms;
}
.carousel-item button {
    opacity: 0 !important;
}
.carousel-item .image-number {
    opacity: 0;
}
/* ACTIVE CAROUSEL ITEM */
/* mobile */
@media only screen and (max-width: 767px ) {
    .carousel .active {
        position: absolute;
        top: 0;
        left: 0;
        transform: scale(1.1);
        box-shadow: 0 0 10px #0002;
    }
    .carousel .active .title {
        overflow: visible;
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-line-clamp: none;
        max-height: 420px;
        transition: max-height cubic-bezier(0.4, 0, 0.2, 1) 150ms;
    }
    .carousel .active .image-number {
        opacity: 0.6;
    }
    .carousel .active button {
        opacity: 1 !important;
    }
}
/* desktop */
@media only screen and (min-width: 768px ) {
    .carousel-item:hover {
        position: absolute;
        top: 0;
        left: 0;
        transform: scale(1.1);
        box-shadow: 0 0 10px #0002;
    }
    .carousel-item:hover .title {
        overflow: visible;
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-line-clamp: none;
        max-height: 420px;
        transition: max-height cubic-bezier(0.4, 0, 0.2, 1) 150ms;
    }
    .carousel-item:hover .image-number {
        opacity: 0.6;
    }
    .carousel-item:hover button {
        opacity: 0.8 !important;
    }
    .carousel-item button:hover {
        opacity: 1 !important;
    }
}
</style>
